import { Header, SearchFilterWrapper, setDateFromStorage } from '@fareye/common'
import { IDateRange } from '@fareye/types'
import { DatePicker, Flex } from '@fareye/ui'
import {
  currenthhmmA,
  getQueryParams,
  getSearchFilterFromSession,
  groupBy,
  isEmpty,
  dMmm,
  yyyyMmDd
} from '@fareye/utils'
import queryString, { ParsedQuery } from 'query-string'
import React from 'react'
import { filterSearchParam } from '../../../utility/funcs'
import { mapping } from '../../../config/mapComponents'
import { EtaGrid } from '../../../style/styled'
import SummaryV2 from '../../../components/SummaryV2'

export function ETA({
  maxRefreshCount,
  refreshInterval,
  location,
  history,
  match,
  config,
  routesConfig,
  baseUrl
}: any) {
  const [isFirst, setIsFirst] = React.useState(false)
  const searchParams: ParsedQuery<string | Date> = queryString.parse(location.search)
  const { children, styling, globalSearchPageId, filters = {} } = config
  let { toggleContent, showSummary, showDatePicker, carryDate } = config.config
  const searchParamsSelectedObj = isEmpty(searchParams)
    ? []
    : filterSearchParam(searchParams)
  const [globalSearch, setGlobalSearch] = React.useState([
    ...getSearchFilterFromSession(globalSearchPageId),
    ...searchParamsSelectedObj
  ])

  const [searchQuery, setSearchQuery] = React.useState({})
  const filterSelectedKey = toggleContent
    ? toggleContent.filter((item: any) => item.link === match.url)
    : []

  const [selectedKey, setSelectedKey] = React.useState(
    filterSelectedKey.length ? filterSelectedKey[0].selectedKey : ''
  )
  const [lastUpdate, setLastUpdate] = React.useState<string>('')

  const { bodyBgColor, layoutStyle } = styling

  const [summaryData, setSummaryData] = React.useState<any>({})
  const [selectedSummaryFilter, setSelectedSummaryFilter] = React.useState<any>({
    numberOfFiltersApplied: 0,
    selectedFilters: {}
  })
  const selectedAggsFilter = React.useMemo(() => {
    return { ...searchQuery, ...selectedSummaryFilter.selectedFilters }
  }, [searchQuery, selectedSummaryFilter])
  const [dateRange, setDateRange] = React.useState(() => {
    return setDateFromStorage({
      showDatePicker: !!showDatePicker,
      carryDate,
      searchParams,
      daysDiff: 20
    })
  })

  const { startDate, endDate } = dateRange as IDateRange<Date>

  function setDateRangeAndStorage(dates: IDateRange<string | Date>) {
    localStorage.setItem('date', JSON.stringify(dates))
    setDateRange(dates as IDateRange<Date>)
  }

  React.useEffect(() => {
    if (showDatePicker) {
      let prevStartDate = searchParams.startDate
      let prevEndDate = searchParams.endDate
      if (prevStartDate !== startDate || prevEndDate !== endDate) {
        const queryParams = getQueryParams({
          ...queryString.parse(location.search),
          startDate,
          endDate
        })
        history.replace({
          pathname: match.url,
          search: queryParams
        })
      }
    }
  }, [dateRange])

  React.useEffect(() => {
    const sq = populateSearchQuery()
    setSearchQuery(sq)
  }, [globalSearch])

  function populateSearchQuery() {
    let searchObj: any = {}
    if (!isEmpty(globalSearch)) {
      const filters = groupBy(globalSearch, 'key')
      Object.keys(filters).forEach((ele: any) => {
        searchObj[ele] = filters[ele].map((item: any) => item.value)
      })
    } else {
      if (!isEmpty(searchQuery)) {
        searchObj = {}
      }
    }

    return searchObj
  }

  const query = {
    ...queryString.parse(location.search)
  }

  const queryParams = getQueryParams(query)
  React.useEffect(() => {
    if (isFirst) {
      setIsFirst(true)
      history.push({
        pathname: match.url,
        search: queryParams
      })
    }
    setLastUpdate(currenthhmmA())
    if (isEmpty(searchQuery)){
      location.search = ''
    }
  }, [queryParams])

  showSummary = showSummary && !isEmpty(summaryData)

  return (
    <Flex column style={{ ...layoutStyle, height: '100%' }}>
      <Header
        match={match}
        toggle={toggleContent}
        history={history}
        location={location}
        lastUpdate={lastUpdate}
        selectedKey={selectedKey}
        routesConfig={routesConfig}
        rightTopCorner={
          showDatePicker ? (
            <DatePicker
              variant="fareyeV2"
              formatter={yyyyMmDd}
              onDateRangeSelected={setDateRangeAndStorage}
              value={dateRange}
            />
          ) : undefined
        }
        setSelectedKey={setSelectedKey}
      >
        <EtaGrid showSummary={showSummary}>
          <div style={{ gridArea: 'left' }}>
            <SearchFilterWrapper
              apiFav={config.filters && (config.filters as any).apiFav}
              search={globalSearch}
              pageId="eta"
              endDate={showDatePicker ? endDate : undefined}
              apiFilter={config.filters && (config.filters as any).apiFilter}
              customKeyMapping={(config.filters as any)?.customKeyMapping}
              startDate={showDatePicker ? startDate : undefined}
              setSearch={setGlobalSearch}
            />
          </div>
          {showSummary ? (
            <div style={{ gridArea: 'summary' }}>
              <SummaryV2
                summaryData={summaryData}
                selectedSummaryFilter={selectedSummaryFilter}
                setSelectedSummaryFilter={setSelectedSummaryFilter}
                singleSelect
              />
            </div>
          ) : null}
        </EtaGrid>
      </Header>
      <div
        style={{
          flexGrow: 1,
          background: bodyBgColor,
          padding: '10px 15px'
        }}
      >
        {Object.keys(children).map((comp: string, i: number) => {
          let ComponentRender: any = mapping['TripTableETA']
          let fileName = `ETA_${dMmm()}`
          return (
            <ComponentRender
              key={comp}
              match={match}
              fileName={fileName}
              mapping={mapping}
              history={history}
              location={location}
              maxRefreshCount={maxRefreshCount}
              refreshInterval={refreshInterval}
              setLastUpdate={setLastUpdate}
              baseUrl={baseUrl}
              searchQuery={selectedAggsFilter}
              selectedKey={selectedKey}
              config={config.children[comp]}
              setSummaryData={setSummaryData}
              startDate={showDatePicker ? startDate : null}
              endDate={showDatePicker ? endDate : null}
            />
          )
        })}
      </div>
    </Flex>
  )
}
